// import React, { useState, useEffect, useCallback } from 'react';
// import axios from 'axios';
// import BlogManagement from './BlogManagement';
// import OfferManagement from './OfferManagement';
// import Payment from './Payment';
// import SuiteManagement from './SuiteManagement';
// import FacebookLinkManagement from './FacebookLinkManagement';
// import VideoLinkManagement from './VideoLinkManagement';
// import './Home.css';

// // Use environment variable with fallback
// const API_URL = 'https://apitop.topranohotelandlounge.com';

// // Add axios response interceptor for better error handling
// axios.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     console.error('API Error:', error.message);
//     return Promise.reject(error);
//   }
// );

// function Home() {
//   const [activeTab, setActiveTab] = useState('dashboard');
//   const [blogs, setBlogs] = useState([]);
//   const [offers, setOffers] = useState([]);
//   const [activeOffer, setActiveOffer] = useState(null);
//   const [transactions, setTransactions] = useState([]);
//   const [suiteTypes, setSuiteTypes] = useState([]);
//   const [facebookLinks, setFacebookLinks] = useState([]);
//   const [videoLinks, setVideoLinks] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [message, setMessage] = useState('');
//   const [error, setError] = useState('');
//   const [retryCount, setRetryCount] = useState(0);

//   // Memoized fetch function to prevent unnecessary re-renders
//   const fetchData = useCallback(async () => {
//     setLoading(true);
//     setMessage('');
//     setError('');
    
//     try {
//       const endpoints = [
//         `${API_URL}/api/blogs`,
//         `${API_URL}/api/offers`,
//         `${API_URL}/api/offers/active`,
//         `${API_URL}/api/bookings`,
//         `${API_URL}/api/suite-types`,
//         `${API_URL}/api/facebooklinks`,
//         `${API_URL}/api/videolinks`
//       ];

//       const [
//         blogsRes, 
//         offersRes, 
//         activeOfferRes, 
//         transactionsRes, 
//         suiteTypesRes, 
//         facebookLinksRes, 
//         videoLinksRes
//       ] = await Promise.all(
//         endpoints.map(endpoint => 
//           axios.get(endpoint, { timeout: 10000 }) // Add timeout
//         )
//       );

//       // Process responses
//       setBlogs(Array.isArray(blogsRes.data) ? blogsRes.data : []);
      
//       setOffers(
//         Array.isArray(offersRes.data) 
//           ? offersRes.data.filter(offer => offer && offer._id)
//           : []
//       );
      
//       setActiveOffer(activeOfferRes.data);
      
//       setTransactions(
//         Array.isArray(transactionsRes.data?.transactions) 
//           ? transactionsRes.data.transactions 
//           : []
//       );
      
//       setSuiteTypes(
//         Array.isArray(suiteTypesRes.data) 
//           ? suiteTypesRes.data.filter(suite => suite && suite._id)
//           : []
//       );
      
//       setFacebookLinks(
//         Array.isArray(facebookLinksRes.data) 
//           ? facebookLinksRes.data.filter(link => link && link.id)
//           : []
//       );
      
//      // FIX: Handle video links response properly
//     let videoLinksData = [];
//     if (videoLinksRes.data) {
//       // Check if the response has the array in data.data or just data
//       if (Array.isArray(videoLinksRes.data.data)) {
//         videoLinksData = videoLinksRes.data.data;
//       } else if (Array.isArray(videoLinksRes.data)) {
//         videoLinksData = videoLinksRes.data;
//       }
//     }
    
//     setVideoLinks(videoLinksData);
//       setRetryCount(0); // Reset retry count on success
//     } catch (error) {
//       console.error('Error fetching data:', error);
      
//       if (retryCount < 3) {
//         setError(`Failed to load data. Retrying (${retryCount + 1}/3)...`);
//         setTimeout(() => {
//           setRetryCount(prev => prev + 1);
//           fetchData();
//         }, 2000);
//       } else {
//         setError('Failed to load dashboard data. Please check your connection and try again.');
//       }
//     } finally {
//       setLoading(false);
//     }
//   }, [retryCount]);

//   useEffect(() => {
//     fetchData();
//   }, [fetchData]);

//   const handleUpdate = (successMessage) => {
//     fetchData();
//     setMessage(successMessage || 'Data updated successfully!');
//     setTimeout(() => setMessage(''), 5000);
//   };

//   const handleTabChange = (tab) => {
//     setActiveTab(tab);
//     // Scroll to top when changing tabs
//     window.scrollTo(0, 0);
//   };

//   if (loading && retryCount === 0) {
//     return (
//       <div className="admin-dashboard">
//         <div className="loading">
//           <div className="spinner"></div>
//           <p>Loading Dashboard...</p>
//           <p className="loading-subtext">Please wait while we fetch your data</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="admin-dashboard">
//       <div className="admin-header">
//         <div className="admin-header-content">
//           <h1 className="admin-title">Admin Dashboard</h1>
          
//           {message && (
//             <div className="alert alert-success">
//               <span className="alert-icon">✓</span>
//               {message}
//             </div>
//           )}
          
//           {error && (
//             <div className="alert alert-error">
//               <span className="alert-icon">⚠</span>
//               {error}
//               {retryCount >= 3 && (
//                 <button 
//                   className="retry-btn"
//                   onClick={() => {
//                     setRetryCount(0);
//                     fetchData();
//                   }}
//                 >
//                   Retry
//                 </button>
//               )}
//             </div>
//           )}
          
//           <div className="admin-tabs">
//             {[
//               { id: 'dashboard', label: 'Dashboard' },
//               { id: 'blogs', label: `Blogs (${blogs.length})` },
//               { id: 'offers', label: `Offers (${offers.length})` },
//               { id: 'transactions', label: `Transactions (${transactions.length})` },
//               { id: 'suites', label: `Suites (${suiteTypes.length})` },
//               { id: 'facebookLinks', label: `Facebook Links (${facebookLinks.length})` },
//               { id: 'videoLinks', label: `Video Links (${videoLinks.length})` }
//             ].map(tab => (
//               <button
//                 key={tab.id}
//                 onClick={() => handleTabChange(tab.id)}
//                 className={`admin-tab ${activeTab === tab.id ? 'active' : ''}`}
//                 aria-selected={activeTab === tab.id}
//               >
//                 {tab.label}
//               </button>
//             ))}
//           </div>
//         </div>
//       </div>
      
//       <div className="admin-content">
//         {activeTab === 'dashboard' && (
//           <DashboardTab
//             blogs={blogs}
//             offers={offers}
//             activeOffer={activeOffer}
//             transactions={transactions}
//             suiteTypes={suiteTypes}
//             facebookLinks={facebookLinks}
//             videoLinks={videoLinks}
//             setActiveTab={setActiveTab}
//           />
//         )}
        
//         {activeTab === 'blogs' && (
//           <BlogManagement blogs={blogs} onUpdate={handleUpdate} />
//         )}
        
//         {activeTab === 'offers' && (
//           <OfferManagement offers={offers} onUpdate={handleUpdate} />
//         )}
        
//         {activeTab === 'transactions' && (
//           <Payment transactions={transactions} onUpdate={handleUpdate} />
//         )}
        
//         {activeTab === 'suites' && (
//           <SuiteManagement suiteTypes={suiteTypes} onUpdate={handleUpdate} />
//         )}
        
//         {activeTab === 'facebookLinks' && (
//           <FacebookLinkManagement 
//             facebookLinks={facebookLinks} 
//             onUpdate={handleUpdate} 
//           />
//         )}
        
//         {activeTab === 'videoLinks' && (
//           <VideoLinkManagement 
//             videoLinks={videoLinks} 
//             onUpdate={handleUpdate} 
//           />
//         )}
//       </div>
//     </div>
//   );
// }

// function DashboardTab({ 
//   blogs, 
//   offers, 
//   activeOffer, 
//   transactions, 
//   suiteTypes, 
//   facebookLinks, 
//   videoLinks, 
//   setActiveTab 
// }) {
//   const stats = [
//     {
//       title: 'Total Blogs',
//       value: blogs.length,
//       color: 'stat-blue',
//       action: () => setActiveTab('blogs')
//     },
//     {
//       title: 'All Offers',
//       value: offers.length,
//       color: 'stat-green',
//       action: () => setActiveTab('offers')
//     },
//     {
//       title: 'Active Offer',
//       value: activeOffer ? 1 : 0,
//       color: 'stat-orange',
//       action: () => setActiveTab('offers')
//     },
//     {
//       title: 'Total Transactions',
//       value: transactions.length,
//       color: 'stat-purple',
//       action: () => setActiveTab('transactions')
//     },
//     {
//       title: 'Total Suite Types',
//       value: suiteTypes.length,
//       color: 'stat-teal',
//       action: () => setActiveTab('suites')
//     },
//     {
//       title: 'Facebook Links',
//       value: facebookLinks.length,
//       color: 'stat-pink',
//       action: () => setActiveTab('facebookLinks')
//     },
//     {
//       title: 'Video Links',
//       value: videoLinks.length,
//       color: 'stat-red',
//       action: () => setActiveTab('videoLinks')
//     }
//   ];

//   return (
//     <div className="dashboard-content">
//       <div className="stats-grid">
//         {stats.map((stat, index) => (
//           <div 
//             key={index} 
//             className="stat-card clickable"
//             onClick={stat.action}
//             tabIndex={0}
//             role="button"
//             aria-label={`View ${stat.title}`}
//             onKeyPress={(e) => {
//               if (e.key === 'Enter' || e.key === ' ') {
//                 stat.action();
//               }
//             }}
//           >
//             <div className="stat-title">{stat.title}</div>
//             <div className={`stat-value ${stat.color}`}>{stat.value}</div>
            
//             {stat.title === 'Active Offer' && activeOffer && (
//               <div className="active-offer-details">
//                 <h4>{activeOffer.title}</h4>
//                 <p>{activeOffer.description}</p>
//                 <span>Expires: {new Date(activeOffer.expiresAt).toLocaleDateString()}</span>
//               </div>
//             )}
//           </div>
//         ))}
        
//         <div className="stat-card">
//           <div className="stat-title">Quick Actions</div>
//           <div className="quick-actions">
//             <button
//               onClick={() => setActiveTab('blogs')}
//               className="btn btn-primary"
//             >
//               Create New Blog
//             </button>
//             <button
//               onClick={() => setActiveTab('offers')}
//               className="btn btn-success"
//             >
//               Create New Offer
//             </button>
//             <button
//               onClick={() => setActiveTab('transactions')}
//               className="btn btn-purple"
//             >
//               View Transactions
//             </button>
//             <button
//               onClick={() => setActiveTab('suites')}
//               className="btn btn-teal"
//             >
//               Manage Suites
//             </button>
//             <button
//               onClick={() => setActiveTab('facebookLinks')}
//               className="btn btn-pink"
//             >
//               Manage Facebook Links
//             </button>
//             <button
//               onClick={() => setActiveTab('videoLinks')}
//               className="btn btn-red"
//             >
//               Manage Video Links
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Home;






// import React, { useState, useEffect, useCallback } from 'react';
// import axios from 'axios';
// import BlogManagement from './BlogManagement';
// import OfferManagement from './OfferManagement';
// import Payment from './Payment';
// import SuiteManagement from './SuiteManagement';
// import FacebookLinkManagement from './FacebookLinkManagement';
// import VideoLinkManagement from './VideoLinkManagement';
// import './Home.css';
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import BlogManagement from './BlogManagement';
import OfferManagement from './OfferManagement';
import Payment from './Payment';
import SuiteManagement from './SuiteManagement';
import FacebookLinkManagement from './FacebookLinkManagement';
import VideoLinkManagement from './VideoLinkManagement';
import './Home.css';
const API_URL = 'https://apitop.topranohotelandlounge.com';

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.message);
    return Promise.reject(error);
  }
);

function Home() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [blogs, setBlogs] = useState([]);
  const [offers, setOffers] = useState([]);
  const [activeOffer, setActiveOffer] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [suiteTypes, setSuiteTypes] = useState([]);
  const [facebookLinks, setFacebookLinks] = useState([]);
  const [videoLinks, setVideoLinks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [retryCount, setRetryCount] = useState(0);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setMessage('');
    setError('');

    try {
      const endpoints = [
        `${API_URL}/api/blogs`,
        `${API_URL}/api/offers`,
        `${API_URL}/api/offers/active`,
        `${API_URL}/api/bookings`,
        `${API_URL}/api/suite-types`,
        `${API_URL}/api/facebooklinks`,
        `${API_URL}/api/videolinks`
      ];

      const [
        blogsRes,
        offersRes,
        activeOfferRes,
        transactionsRes,
        suiteTypesRes,
        facebookLinksRes,
        videoLinksRes
      ] = await Promise.all(
        endpoints.map(endpoint => axios.get(endpoint, { timeout: 10000 }))
      );

      setBlogs(Array.isArray(blogsRes.data) ? blogsRes.data : []);
      setOffers(Array.isArray(offersRes.data) ? offersRes.data.filter(o => o && o._id) : []);
      setActiveOffer(activeOfferRes.data);
      setTransactions(Array.isArray(transactionsRes.data?.transactions) ? transactionsRes.data.transactions : []);
      setSuiteTypes(Array.isArray(suiteTypesRes.data) ? suiteTypesRes.data.filter(s => s && s._id) : []);
      setFacebookLinks(Array.isArray(facebookLinksRes.data) ? facebookLinksRes.data.filter(l => l && l.id) : []);

      let videoLinksData = [];
      if (videoLinksRes.data) {
        videoLinksData = Array.isArray(videoLinksRes.data.data) 
          ? videoLinksRes.data.data 
          : Array.isArray(videoLinksRes.data) 
          ? videoLinksRes.data 
          : [];
      }
      setVideoLinks(videoLinksData);

      setRetryCount(0);
    } catch (err) {
      console.error('Error fetching data:', err);
      if (retryCount < 3) {
        setError(`Failed to load data. Retrying (${retryCount + 1}/3)...`);
        setTimeout(() => {
          setRetryCount(prev => prev + 1);
          fetchData();
        }, 2000);
      } else {
        setError('Failed to load dashboard data. Please check your connection and try again.');
      }
    } finally {
      setLoading(false);
    }
  }, [retryCount]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleUpdate = (successMessage) => {
    fetchData();
    setMessage(successMessage || 'Operation completed successfully!');
    setTimeout(() => setMessage(''), 5000);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    window.scrollTo(0, 0);
  };

  // Navigate to Create Suite Page
  const goToCreateSuite = () => {
    window.location.href = '/create';
  };

  if (loading && retryCount === 0) {
    return (
      <div className="admin-dashboard">
        <div className="loading">
          <div className="spinner"></div>
          <p>Loading Dashboard...</p>
          <p className="loading-subtext">Please wait while we fetch your data</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-dashboard">
      <div className="admin-header">
        <div className="admin-header-content">
          <h1 className="admin-title">Admin Dashboard</h1>

          {message && (
            <div className="alert alert-success">
              <span className="alert-icon">✓</span> {message}
            </div>
          )}

          {error && (
            <div className="alert alert-error">
              <span className="alert-icon">⚠</span> {error}
              {retryCount >= 3 && (
                <button className="retry-btn" onClick={() => { setRetryCount(0); fetchData(); }}>
                  Retry
                </button>
              )}
            </div>
          )}

          <div className="admin-tabs">
            {[
              { id: 'dashboard', label: 'Dashboard' },
              { id: 'blogs', label: `Blogs (${blogs.length})` },
              { id: 'offers', label: `Offers (${offers.length})` },
              { id: 'transactions', label: `Transactions (${transactions.length})` },
              { id: 'suites', label: `Suites (${suiteTypes.length})` },
              { id: 'facebookLinks', label: `Facebook Links (${facebookLinks.length})` },
              { id: 'videoLinks', label: `Video Links (${videoLinks.length})` },
              { id: 'create-suite', label: 'Create Suite' }
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => (tab.id === 'create-suite' ? goToCreateSuite() : handleTabChange(tab.id))}
                className={`admin-tab ${activeTab === tab.id ? 'active' : ''}`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="admin-content">
        {activeTab === 'dashboard' && (
          <DashboardTab
            blogs={blogs}
            offers={offers}
            activeOffer={activeOffer}
            transactions={transactions}
            suiteTypes={suiteTypes}
            facebookLinks={facebookLinks}
            videoLinks={videoLinks}
            setActiveTab={setActiveTab}
            goToCreateSuite={goToCreateSuite}
          />
        )}

        {activeTab === 'blogs' && <BlogManagement blogs={blogs} onUpdate={handleUpdate} />}
        {activeTab === 'offers' && <OfferManagement offers={offers} onUpdate={handleUpdate} />}
        {activeTab === 'transactions' && <Payment transactions={transactions} onUpdate={handleUpdate} />}
        {activeTab === 'suites' && <SuiteManagement suiteTypes={suiteTypes} onUpdate={handleUpdate} />}
        {activeTab === 'facebookLinks' && <FacebookLinkManagement facebookLinks={facebookLinks} onUpdate={handleUpdate} />}
        {activeTab === 'videoLinks' && <VideoLinkManagement videoLinks={videoLinks} onUpdate={handleUpdate} />}
      </div>
    </div>
  );
}

function DashboardTab({
  blogs,
  offers,
  activeOffer,
  transactions,
  suiteTypes,
  facebookLinks,
  videoLinks,
  setActiveTab,
  goToCreateSuite
}) {
  const stats = [
    { title: 'Total Blogs', value: blogs.length, color: 'stat-blue', action: () => setActiveTab('blogs') },
    { title: 'All Offers', value: offers.length, color: 'stat-green', action: () => setActiveTab('offers') },
    { title: 'Active Offer', value: activeOffer ? 1 : 0, color: 'stat-orange', action: () => setActiveTab('offers') },
    { title: 'Total Transactions', value: transactions.length, color: 'stat-purple', action: () => setActiveTab('transactions') },
    { title: 'Total Suite Types', value: suiteTypes.length, color: 'stat-teal', action: () => setActiveTab('suites') },
    { title: 'Facebook Links', value: facebookLinks.length, color: 'stat-pink', action: () => setActiveTab('facebookLinks') },
    { title: 'Video Links', value: videoLinks.length, color: 'stat-red', action: () => setActiveTab('videoLinks') },
  ];

  return (
    <div className="dashboard-content">
      <div className="stats-grid">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="stat-card clickable"
            onClick={stat.action}
            tabIndex={0}
            role="button"
          >
            <div className="stat-title">{stat.title}</div>
            <div className={`stat-value ${stat.color}`}>{stat.value}</div>
          </div>
        ))}

        <div className="stat-card">
          <div className="stat-title">Quick Actions</div>
          <div className="quick-actions">
            <button onClick={() => setActiveTab('blogs')} className="btn btn-primary">
              Create New Blog
            </button>
            <button onClick={() => setActiveTab('offers')} className="btn btn-success">
              Create New Offer
            </button>
            <button onClick={goToCreateSuite} className="btn btn-teal">
              + Create New Suite
            </button>
            <button onClick={() => setActiveTab('suites')} className="btn btn-indigo">
              Manage Suites
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;